import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { depreciationStatusClassNameConfig } from './DepreciationStatusClass.name';

/** 償却状況区分のENUM */
enum DepreciationStatusClass {
  depreciating = '1',
  residualAchievement = '2',
  residualDepreciation = '3',
  depreciationComplete = '4',
}

const depreciationStatusClassMap = new Map([
  ['1', DepreciationStatusClass.depreciating],
  ['2', DepreciationStatusClass.residualAchievement],
  ['3', DepreciationStatusClass.residualDepreciation],
  ['4', DepreciationStatusClass.depreciationComplete],
]);

const rawValueToDepreciationStatusClass = rawValueToEnumWithDefault(
  depreciationStatusClassMap,
  DepreciationStatusClass.depreciating,
);

const depreciationStatusClassToDisplay = enumToNameWithDefault(
  DepreciationStatusClass,
  depreciationStatusClassNameConfig,
);

const depreciationStatusClassToDisplayWithPrefix = enumToNameWithDefault(
  DepreciationStatusClass,
  depreciationStatusClassNameConfig,
  true,
);

export {
  DepreciationStatusClass,
  depreciationStatusClassToDisplay,
  depreciationStatusClassToDisplayWithPrefix,
  rawValueToDepreciationStatusClass,
};
